import React from 'react';
import helloThereGif from '../../../static/hello_there.gif';

const HelloThere = () => {
  return (
    <img src={helloThereGif} alt="hi" />
  )
}

export default HelloThere;
